<div class="content-modal">
    <form [formGroup]="healthForm">
      <div>
        <span class="fw-extrabold fs-4">{{healt.title}}</span>
      </div>
      <hr>
      <div class="content-description w-100 mb-3">
        <span class="fw-regular">{{healt.description}}</span>
      </div>
      <div [ngClass]=" !textError ? 'mb-5' : 'mb-3'">
        <img [src]="healt.subtitles[0].icon" class="me-3" alt="">
        <span class="fw-regular fs-6">{{healt.subtitles[0].title}}</span>
      </div>
      <div class="mb-2">
        <span class="text-danger">{{textError}}</span>
      </div>
      <div class="row">
        <div class="col-md-4 mb-5">
          <div class="w-100">
            <input class="w-100 border-0 border-bottom fw-semibold" formControlName="name" [placeholder]="healt.subtitles[0].placeholders[0] + '*'">
          </div>
        </div>
        <div class="col-md-4 mb-5">
          <div class="w-100">
            <input class="w-100 border-0 border-bottom fw-semibold" formControlName="lastname" [placeholder]="healt.subtitles[0].placeholders[1] + '*'">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 mb-5">
          <div class="w-100">
            <input class="w-100 border-0 border-bottom fw-semibold" formControlName="email" [placeholder]="healt.subtitles[0].placeholders[2] + '*'">
          </div>
        </div>
        <div class="col-md-4 mb-5">
          <div class="w-100">
            <input class="w-100 border-0 border-bottom fw-semibold" formControlName="country" [placeholder]="healt.subtitles[0].placeholders[3] + '*'">
          </div>
        </div>
        <div class="col-md-4 mb-5">
          <div class="w-100">
            <input class="w-100 border-0 border-bottom fw-semibold" formControlName="city" [placeholder]="healt.subtitles[0].placeholders[4] + '*'">
          </div>
        </div>
      </div>
      <div class="mb-4">
        <img [src]="healt.subtitles[1].icon" class="me-3" alt="">
        <span class="fw-regular fs-6">{{healt.subtitles[1].title}}</span>
      </div>
      <div class="row profesions mb-4 sp-center">
        <div *ngFor="let op of healt.subtitles[1].placeholders" class="content-profesion d-flex al-center sp-center 
        rounded-pill animated pointer" (click)="changeSelected(op)" [ngClass]=" op.selected ? 'bg-blue':'border-sky' ">
          <span class="fw-regular fs-6" [ngClass]=" op.selected ? 'text-white':'text-sky'">{{op.label}}</span>
        </div>
      </div>
      <div class="mb-4 mb-sm-5">
        <label class="fw-regular d-flex al-center">
          <input type="checkbox" id="cbox1" value="first_checkbox" class="me-2 checkbox" formControlName="checked" />
        {{healt.terms}}</label>
      </div>
      <div class="d-flex flex-column flex-md-row actions sp-center">
        <div class="btn-button bg-white w-100 d-flex al-center sp-center back rounded-pill" routerLink="/" mat-dialog-close>
          <span class="text-blue fs-4 fw-medium">{{healt.actions[0]}}</span>
        </div>
        <div class="btn-button bg-blue w-100 d-flex al-center sp-center rounded-pill animated pointer" (click)="saveForm()">
          <span class="text-white fs-4 fw-medium">{{healt.actions[1]}}</span>
        </div>
      </div>
    </form>
</div>